export default "__VITE_PUBLIC_ASSET__f7abb531__"